//@flow

import React from 'react'
import Configurator from '../../../configurator'
import { AVAILABLE_LANGUAGES } from '../../../consts'
import {
    authedUserConnect,
    withRouter,
} from '../../../validator'
import OverlayLoader from '../../../components/shared/overlay-loader'
import { languagePath } from '../../../locales/helpers'
import { asyncLocalStorage } from '../../../admin/store'
import { updateApiLanguage } from '../../../locales/language-setter'

/**
 * @param {string} language
 * @description Base language switcher
 *      USAGE
 *          <LanguageSwitcher />
 */
@withRouter()
@authedUserConnect()
export default class LanguageSwitcher extends Configurator {
    state = {
        busy: false,
    }

    changeLanguage = language => {
        const { authedUser } = this.props

        asyncLocalStorage.setItem('language', language)
        let apiPromise = Promise.resolve()

        if (authedUser) {
            apiPromise = updateApiLanguage(language)
        }

        apiPromise
            .then(() => {
                window.location.href = window.location.pathname.replace(languagePath(true, true), `/${language}/`)
            })
    }

    /**
     * Render LanguageSwitcher to set system language
     *
     * @return {*}
     */
    render = () => {
        const { REACT_APP_FOOTER_LANGUAGE } = this.config
        const { busy } = this.state

        if (!REACT_APP_FOOTER_LANGUAGE) {
            return null
        }

        return (
            <div className="d-flex">
                {AVAILABLE_LANGUAGES.map((availableLanguage, index) => (
                    <div
                        key={index}
                        title={availableLanguage.toUpperCase()}
                        className="btn pl-0 pt-0"
                        onClick={() => this.changeLanguage(availableLanguage)}
                    >
                        <img src={`/images/lang/${availableLanguage}.svg`} alt={availableLanguage} />
                    </div>
                ))}

                {busy && <OverlayLoader />}
            </div>
        )
    }
}
